// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2pkNxLsOdWJcupo8pwROgt","icon":"_3UhLwH023k7ApJtYzttX6U","active":"_1RU_DiwAPUPMbcduWvRfhv"};